import { formatNumberGivenValueType } from 'modules/productAnalytics/utils';
import styled from 'styled-components';
import { NUMBER, PERCENTAGE } from 'ui/card/constants';

import { Cell, RightAlignText, TabularNumberFont } from '../../components/Styled';

const StyledRightAlignText = styled(RightAlignText)`
  text-align: right;
`;
type MetricCellProps = {
  primaryVal: number;
  valueType: typeof NUMBER | typeof PERCENTAGE;
};

export const MetricCell = ({ primaryVal, valueType }: MetricCellProps) => {
  return (
    <Cell>
      <StyledRightAlignText>
        <div>
          <TabularNumberFont>{formatNumberGivenValueType(valueType, primaryVal)}</TabularNumberFont>
        </div>
      </StyledRightAlignText>
    </Cell>
  );
};
